import {IChannel} from "../../../../interfaces/IChannel.ts";
import {ISearchEpgItem} from "../../../../interfaces/ISearchEpgItem.ts";
import LiveIndicator from "../../../shared/widgets/LiveIndicator.tsx";
import DateHelper from "../../../../helpers/dateHelper.ts";
import {PlayIcon} from "@heroicons/react/24/solid";

interface IProps {
    channel?: IChannel,
    favorite: ISearchEpgItem,
}

const AccountFavoriteCurrentItem = ({favorite, channel}: IProps) => {
    return (
        <div className={'flex justify-between w-full px-3 py-1.5 border-b border-neutral-600'}>
            <div className={"flex flex-col"}>
                <span className={"text-sm text-neutral-400"}>{channel?.name ?? ""}</span>
                <h2>{favorite.name}</h2>
                <div className={"flex gap-1 text-[#009ee3] text-sm"}>
                    <time dateTime={DateHelper.DateTimeFromUnixTimestamp(favorite.time).toISOString()}>
                        {DateHelper.GetHourAndMinuteFromDate(DateHelper.DateTimeFromUnixTimestamp(favorite.time))}
                    </time>
                    <span> - </span>
                    <time dateTime={DateHelper.DateTimeFromUnixTimestamp(favorite.timeTo).toISOString()}>
                        {DateHelper.GetHourAndMinuteFromDate(DateHelper.DateTimeFromUnixTimestamp(favorite.timeTo))}
                    </time>
                </div>
            </div>
            <div className={"flex items-center gap-3"}>
                <LiveIndicator/>
                <div className={`border-2  rounded-full p-1 ${channel?.enabled ? "border-[#008DD2]" : "border-neutral-950"}`}>
                    <PlayIcon className={`w-3 h-3 ${channel?.enabled ? "text-[#008DD2]" : "text-neutral-950"}`}/>
                </div>
            </div>
        </div>
    );
};

export default AccountFavoriteCurrentItem;

// <div className={'flex justify-between w-full items-center p-2 py-1 border-b border-neutral-600'}>
//     <div className={"flex flex-col w-full"}>
//         <div className={"flex justify-between w-full text-neutral-400 text-sm"}>
//             <time dateTime={DateHelper.DateTimeFromUnixTimestamp(item.time).toISOString()}>
//                 {DateHelper.DateTimeFormatForEpgDetails(DateHelper.DateTimeFromUnixTimestamp(item.time))}
//             </time>
//             <span>
//                         {channel?.name ?? ""}
//                     </span>
//         </div>
//         <strong>
//             {item.name}
//         </strong>
//         {item.episode > 0 &&
//             <span className={"text-neutral-400 text-sm"}>
//                         Odcinek {item.episode}
//                     </span>
//         }
//         {item.realId}
//     </div>
//     {/*<div className={"flex"}>*/}
//     {/*    <ChevronRightIcon className={"w-8 h-8 text-[#008dd2]"}/>*/}
//     {/*</div>*/}
// </div>